<div class="individual-data-form-group" [formGroup]="form">
  <div class="form-group" [hidden]="hiddenControls['fullName']">

    <app-integrations-entity-search-control
      formControlName="fullName"
      [switchBtnText]="readonly ? '' : 'Former Name'"
      [entityType]="entityType"
      [suggestions]="fullNameSuggestions"
      [label]="individualDataFormLabels.fullName"
      [readonly]="readonly"
      (individualSelected)="onIndividualSelected($event)"
      (switchBtnClick)="formerNameVisible = !formerNameVisible"
    />
  </div>

  <div class="form-group" [hidden]="hiddenControls['formerFullName'] || !formerNameVisible || readonly">
    <app-input
      formControlName="formerFullName"
      [label]="individualDataFormLabels.formerFullName"
      [customErrors]="directorFullNameValidatorMsg"
    />
  </div>

  <div class="birth-data">
    <div class="form-group" [hidden]="hiddenControls['dob']">
      <app-date-picker
        formControlName="dob"
        [label]="individualDataFormLabels.dob"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [customErrors]="dateOfBirthCustomErrors"
      />
    </div>

    <div class="form-group" [hidden]="hiddenControls['birthCountry']">
      <app-flags-autocomplete
        formControlName="birthCountry"
        [label]="individualDataFormLabels.birthCountry"
        [options]="countryOptions"
      />
    </div>

    <div class="form-group" [hidden]="hiddenControls['birthCity']">
      @if (isAustraliaSelected()) {
        <app-suburbs-autocomplete
          formControlName="birthCity"
          [label]="individualDataFormLabels.birthCity"
        />
      } @else {
        <app-input
          formControlName="birthCity"
          [label]="individualDataFormLabels.birthCity"
        />
      }
    </div>
  </div>

  <div class="form-group address-form-group-wrapper" [hidden]="hiddenControls['address']">
    <app-address-form-group
      [formGroup]="form.controls.address"
      [useInternationalAddresses]="useInternationalAddresses"
      [expandedAddressForm]="expandedAddressForm"
      [suggestedAddresses]="suggestedAddresses"
      [readonly]="readonly"
    />
  </div>
</div>
